import autoRefresh, { set } from '#utilities/js/ea/refresh.js'
import contract, { selectors } from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import anchor from './anchor.js'
import autofocus from './autofocus.js'
import button from './button.js'
import contextMenu from './contextMenu.js'
import deferred from './deferred/deferred.js'
import disabled from './disabled.js'
import drag from './drag.js'
import dragSelection from './dragSelection.js'
import drop from './drop.js'
import fetchers from './fetchers/fetchers.js'
import file from './file.js'
import fixed from './fixed.js'
import form from './form.js'
import fragments from './fragments.js'
import hotkeys from './hotkeys/hotkeys.js'
import permissions from './permissions.js'
import refresh from './refresh.js'
import scope from './scope.js'
import submitter from './submitter.js'
import templates from './templates/templates.js'
import toggleAll from './toggleAll.js'
import popupWindow from './popupWindow.js'
import iframe from './iframe.js'

export default contract({
  [selectors]: {
    ...deferred[selectors],
    ...fetchers[selectors],
    ...hotkeys[selectors],
    ...templates[selectors],
    ':scope': array([
      autofocus,
      disabled,
      dragSelection,
      refresh
    ]),
    ':scope > template': array([
      fragments
    ]),
    'a[data-target="popupWindow"]': array([
      popupWindow
    ]),
    'a:not([href="javascript:"]):not([download]):not([target]).ea_generics__listenable, a[data-download][target="_self"]:not([href="javascript:"]).ea_generics__listenable': array([
      anchor
    ]),
    '[type="submit"][form="mainform"]': array([
      submitter
    ]),
    'form#mainform': array([
      form
    ]),
    'form:not([target]) button.ea_generics__listenable:not([form="mainform"]), form:not([target]) [type="submit"].ea_generics__listenable:not([form="mainform"]), [type="submit"][data-contract~="targeting.submit"].ea_generics__listenable': array([
      button
    ]),
    '[data-client-x][data-client-y]': array([
      fixed
    ]),
    '#div_contextmenu': array([
      contextMenu
    ]),
    '[data-scope-json]': array([
      scope
    ]),
    '[draggable="true"][data-drag-type]': array([
      drag
    ]),
    '[data-drop-accept]': array([
      drop
    ]),
    '[data-permissions]': array([
      permissions
    ]),
    '[data-toggle-all]': array([
      toggleAll
    ]),
    /**
     * @todo ANYONE remove the label from the selector once input[type="file"] are pretty
     */
    'label input[type="file"]': array([
      file
    ]),
    '.ea_generics__iframe': array([
      iframe
    ]),
    'meta[name="ea_refresh"][content]': array([
      autoRefresh
    ]),
    '[data-refresh-state][data-refresh-uuid]': array([
      set
    ]),
  }
})
